import { defineStore } from "pinia";
import SegmentDO = App.Data.Segments.SegmentDO;
import { useApiClient } from "@/api/client";

type MinimalSegment = Pick<
	SegmentDO,
	"id" | "title" | "has_dependency_on_lost_customer_segment"
>;

export const useSegmentStore = defineStore({
	id: "segmentStore",
	state() {
		return {
			segments: [] as MinimalSegment[],
		};
	},
	actions: {
		async load() {
			const client = useApiClient("explorer");
			const params = {
				page: 1,
				itemsPerPage: 100,
			};
			this.segments = [];
			let hasMorePages = false;

			do {
				const response = await client.indexSegments({
					...params,
					sortBy: [{ key: "title", order: "asc" }],
				});

				if (response.isOk()) {
					this.segments = [...this.segments, ...response.value.data];

					hasMorePages = !!response.value.next_page_url;
					params.page++;
				} else {
					break;
				}
			} while (hasMorePages);
		},
	},
});
